import { render, staticRenderFns } from "./AbsenceRequestForm.vue?vue&type=template&id=283a1096&"
import script from "./AbsenceRequestForm.vue?vue&type=script&lang=js&"
export * from "./AbsenceRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports